import React from "react"
import {connect} from "react-redux";
import PaymentMethods from "./PaymentMethods";
import PaymentPlansSelection from "./PaymentPlansSelection";
import {Row, Grid} from "react-bootstrap";
import {URLs, PaymentTypes} from "../../common/constants";
import {setPaymentPlan, setPaymentMethod, setCustomAmount} from "../../actions/common/subscriptionSummaryActions";
import {setDirty} from '../../actions/common/commonActions';

class PaymentPane extends React.Component {
    setPaymentMethod = (paymentMethod) => {
        this.props.setPaymentMethod(paymentMethod, this.props.paymentType);
    };

    setPaymentPlan = (paymentPlan) => {
        this.props.setPaymentPlan(paymentPlan, this.props.paymentType);
    };

    showPaymentMethods = () => {
        if(this.props.hasToken && this.props.paymentType === PaymentTypes.AUTO_PAYMENT.type) {
            return null;
        } else if(!this.props.hasToken && this.props.paymentType === PaymentTypes.UPDATE_PAYMENT.type) {
            return null;
        }
        else {
            return (<Row key="payment-methods">
                <PaymentMethods paymentMethods={this.props.paymentMethods}
                                setSelectedMethod={this.setPaymentMethod}
                                pageContext={URLs.PAY}
                                selectedMethod={this.props[this.props.paymentType + "PaymentMethod"]}
                                paymentType={this.props.paymentType}
                                hasToken={this.props.hasToken}/>
            </Row>);
        }
    };

    showPaymentPlans = () => {
        return (
            <Row key="payment-plans">
                <PaymentPlansSelection paymentPlans={this.props.paymentPlans}
                                       paymentPlan={this.props[this.props.paymentType + "PaymentPlan"]}
                                       setPaymentPlan={this.setPaymentPlan}
                                       customAmount={this.props.customAmount}
                                       setCustomAmount={this.props.setCustomAmount}
                                       paymentType={this.props.paymentType}
                                       allowNone={this.props.allowNone}
                                       balance={this.props.balance}/>
            </Row>);
    };

    render() {
        return(
            <Grid>
                {this.showPaymentPlans()}
                {this.showPaymentMethods()}
            </Grid>);
    }
}

const mapStateToProps = (state) => {
    const summary = state.summary;
    return {
        singlePaymentPlan: summary.singlePaymentPlan,
        singlePaymentMethod: summary.singlePaymentMethod,
        autoPaymentPlan: summary.autoPaymentPlan,
        autoPaymentMethod: summary.autoPaymentMethod,
        updatePaymentMethod: summary.updatePaymentMethod,
        chargePaymentPlan: summary.chargePaymentPlan,
        chargePaymentMethod: summary.chargePaymentMethod,
        planPaymentPlan: summary.planPaymentPlan,
        tokenPaymentMethod: summary.tokenPaymentMethod,
        customAmount: summary.customAmount,
        balance: summary.balance
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPaymentMethod: (paymentMethod, paymentType) => {
            dispatch(setPaymentMethod(paymentMethod, paymentType));
            dispatch(setDirty(true));
        },
        setPaymentPlan: (paymentPlan, paymentType) => {
            dispatch(setPaymentPlan(paymentPlan, paymentType));
            dispatch(setDirty(true));
        },
        setCustomAmount: (customAmount) => {
            dispatch(setCustomAmount(customAmount));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (PaymentPane);


// WEBPACK FOOTER //
// ./src/components/pay/PaymentPane.js